module.exports = {
          srcSet: __webpack_public_path__ + "60fd0e3b9e9a28aa2398c38b0a129647-154.png"+" 154w",
          images:[ {path: __webpack_public_path__ + "60fd0e3b9e9a28aa2398c38b0a129647-154.png",width: 154,height: 36}],
          src: __webpack_public_path__ + "60fd0e3b9e9a28aa2398c38b0a129647-154.png",
          toString:function(){return __webpack_public_path__ + "60fd0e3b9e9a28aa2398c38b0a129647-154.png"},
          
          width: 154,
          height: 36
        }